var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumb',{attrs:{"items":_vm.breadcrumbItems}}),_c('ProgramaForm',{on:{"save":_vm.handleSave,"cancel":_vm.handleCancel,"error":_vm.handleError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }